export function OfferMessage({ emoji, title, text }: { emoji: string; title: string; text?: string }) {
  return (
    <div className="text-center py-6">
      <div className="text-5xl mb-4" aria-hidden="true">{emoji}</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
      {text && <p className="text-gray-600">{text}</p>}
    </div>
  )
}

export function OfferSpinner() {
  return (
    <div className="flex justify-center py-12">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
    </div>
  )
}
